import React, { useState, useEffect, useRef } from 'react'
import { useSlate, ReactEditor } from 'slate-react'
import { Transforms, Editor, Element, Text, Node } from 'slate'
import { getLastNode } from '@udecode/slate-plugins'
import clsx from 'clsx';
import {UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem} from 'reactstrap';

import { MARK_FONT_SIZE } from '../Canvas/TratoFormat/Marks'
import { getFullDocumentRange, updateAllTextNodes, updateSpecialTextNodes } from '../Canvas/TratoFormat/editor-utils'
import useOnClickOutside from 'hooks/useOnClickOutside'

const defaultFontSize = '12px';

export default function FontSizeButton({ isDisabled }) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentSize, setCurrentSize] = useState(defaultFontSize)
  const editor = useSlate()
  const { selection } = editor;

  useEffect(() => {
    try {
      const marks = Editor.marks(editor);
      if (marks) {
        const fontSize = marks?.[MARK_FONT_SIZE] ? marks[MARK_FONT_SIZE] : defaultFontSize
      
        setCurrentSize(fontSize)  
      }
    } catch {
      setCurrentSize(defaultFontSize)  
    }  
  }, [editor, selection])

  const handleClick = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    setIsOpen(true)
  };

  const handleClose = () => setIsOpen(false);

  const handleChange = ({ value }) => {
    try {
      const { selection } = editor;
      
      
      if (selection) {
        // ReactEditor.focus(editor);
        // Transforms.select(editor, selection);
        editor.addMark(MARK_FONT_SIZE, value);
        updateSpecialTextNodes(editor, { [MARK_FONT_SIZE]: value })
        // Transforms.setNodes(editor, { [MARK_FONT_SIZE]: value }, {
        //   mode: 'all',
        //   voids: true,
        //   match: (n) => ['variable', 'statement', 'clause', 'li'].includes(n.type)
        // })
        setIsOpen(false)
        // Transforms.deselect(editor)
      } else {
        
        // updateAllTextNodes(editor, { [MARK_FONT_SIZE]: value }, {
        //   specialTextNodes: true
        // });        
      }

      setCurrentSize(value);
    } catch (error) {
      console.error('FontSizeError', error)
    }
    
  };

  return (
    <UncontrolledDropdown tag="span" className="align-self-center" disabled={isDisabled}>
      <DropdownToggle className="px-0" color="light" disabled={isDisabled}>
        {currentSize}
        <i className="fas fa-angle-down fa-fw" />
      </DropdownToggle>
      <DropdownMenu>
      {
          fontSizeOptions.map(option => 
            <MenuOption key={option.value} value={option.value} isActive={currentSize === option.value} onClick={handleChange}>{option.label}</MenuOption>
          )
        } 
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

function Menu({ isOpen, children , onClose}) {
  const [internalIsOpen, setInternalIsOpen] = useState(isOpen);
  const menuRef = useRef();
  useOnClickOutside(menuRef, (evt) => {
    evt.preventDefault();
    setInternalIsOpen(false)
    onClose()
  })


  useEffect(() => {
    setInternalIsOpen(isOpen)
  }, [isOpen])

  if (!internalIsOpen) {
    return null;
  }

  return (
    <div className="font-size-select_menu shadow" ref={menuRef}>
      {children}
    </div>
  )
}

function MenuOption({ onClick, isActive, value, children}) {

  const handleClick = (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      onClick({ value })
  }

  return (
    <DropdownItem className={clsx(isActive && 'active')} onMouseDown={handleClick}>
      {children}
    </DropdownItem>
  )
}

const fontSizeOptions = [
  { label: '6 px', value: '6px' }, 
  { label: '7 px', value: '7px' }, 
  { label: '8 px', value: '8px' }, 
  { label: '9 px', value: '9px' }, 
  { label: '10 px', value: '10px' }, 
  { label: '11 px', value: '11px' }, 
  { label: '12 px', value: '12px' }, 
  { label: '13 px', value: '13px' }, 
  { label: '14 px', value: '14px' }, 
  { label: '15 px', value: '15px' }, 
  { label: '16 px', value: '16px' }, 
  { label: '18 px', value: '18px' }, 
  { label: '20 px', value: '20px' }, 
  { label: '22 px', value: '22px' }, 
  { label: '24 px', value: '24px' }, 
  { label: '30 px', value: '30px' }, 
  { label: '36 px', value: '36px' }, 
  { label: '42 px', value: '42px' }, 
  { label: '48 px', value: '48px' }, 
]